<template>
  <div class="orderContainer">
    <!-- <div class="isShowLoading" color="#aab" v-if="isShowLoading">
      <van-loading vertical type="spinner" />
      <van-overlay :show="isShowLoading" />
    </div> -->
    <div class="expressContainer">
      <van-popup v-model="show" round position="bottom" :style="{ height: '80%' }">
        <div v-if="steps.status == 0" style="overflow: hidden">
          <div class="expressTop">
            <!-- <h3>物流信息</h3> -->
            <div class="flexWrap">
              <div>
                <div class="expressPhone">
                  {{ steps.result.expName }} :
                  <span class="fontWeight">{{ steps.result.number }}</span>
                </div>
                <div class="expressPhone">
                  <span class="name">官方电话 : </span>
                  <span class="fontWeight" @click="callPhone(steps.result.expPhone)">{{ steps.result.expPhone }}</span>
                </div>
              </div>

              <span class="code expressPhone" :data-clipboard-text="steps.result.number" @click="copy">复制</span>
            </div>
          </div>

          <div class="between" v-if="steps.result.deliverystatus == '2'">
            <div class="flex">
              <div class="name">{{ steps.result.courier }} :</div>
            </div>
            <div class="callexpressName" @click="callPhone(steps.result.courierPhone)">
              联系快递员
            </div>
          </div>
          <div class="stepsExpress">
            <van-steps direction="vertical" :active="active" active-color="#000">
              <van-step v-for="(item, index) in steps.result.list" :key="index">
                <template #active-icon v-if="steps.result.deliverystatus == '3'">
                  <div class="collect">收</div>
                </template>
                <template #inactive-icon v-if="steps.result.deliverystatus == '1'">
                  <van-icon name="logistics" />
                </template>

                <!--  <div v-if="steps.result.deliverystatus == '2'">正在派件</div>
            <div v-if="steps.result.deliverystatus == '1'">在途中</div>
            <div v-if="steps.result.deliverystatus == '0'">快递收件(揽件)</div> -->
                <p>
                  {{ item.status }}
                </p>
                {{ item.time }}
                <!-- </div> -->
              </van-step>
            </van-steps>
          </div>
        </div>
        <div class="index-empty" v-else>
          <div class="imageEmptySearch">
            <img src="../../../assets/images/search.png" alt />
          </div>
          <!-- <div class="describe">{{ steps.msg }}</div> -->
        </div>
      </van-popup>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <van-cell v-if="order.cellPhone != undefined" :title="order.name + ' ' + order.cellPhone" :label="'收货地址：' +
      order.province +
      order.city +
      order.district +
      order.detail
      " clickable style="margin-bottom: 5px" value-class="address-tel" class="address" size="large"></van-cell>

    <van-list class="cardList">
      <!-- :title="
          order.orderStatus == 'submitted'
            ? '订单将于' + cancelTimer + '分钟后自动取消'
            : '订单商品'
        "
        :status="getChineseStatus(order.orderStatus)" -->
      <van-panel>
        <template slot="header">
          <div class="orderBottom">
            <div class="flex-between">
              <div class="orderHeaderTopBetween">
                <div class="orderIcon" v-if="order.orderClass == 1">
                  <svg class="orderIcon" aria-hidden="true">
                    <use xlink:href="#icon-daimaitubiao"></use>
                  </svg>
                </div>
                {{ "订单编号：" + order.orderId }}
                <div @click="copyCodeOrder($event, order.orderId)" class="codeOrderId">
                  复制
                </div>
              </div>
              <div class="orderHeaderTop panelStatus">
                {{ getChineseStatus(order.orderStatus) }}
              </div>
            </div>
          </div>
        </template>
        <van-card v-for="item in order.orderItems" :key="item.goodsCode" :num="item.quantity" :title="item.itemName"
          :desc="item.itemSpecs" :thumb="item.picture" class="shopCard" />
        <van-panel v-if="orderGiftItems.length !== 0" :border="false">
          <template slot="header">
            <div class="flex-between orderBottomGift">
              <!-- 绑定用户可以有新人大礼包 -->
              <!-- win 根据返回类型判断是否展示新人大礼包价格 -->

              <div class="panelHeader red" v-if="(userInfo.userType !== 'common' ||
                userInfo.statusName !== 'limited') && orderGiftItems[0].goodsType == 2">新人首单大礼包</div>
              <!-- 店员店长可以有赠品 -->
              <div class="panelHeader red" v-else>赠品</div>
            </div>
          </template>
          <van-card v-for="item in orderGiftItems" :key="item.goodsCode" :num="item.quantity" :title="item.itemName"
            :desc="item.itemSpecs" :thumb="item.picture" class="shopCard" />
        </van-panel>
        <div class="orderList">
          <van-cell :border="false" title="运费" value="包邮"></van-cell>
          <van-cell :border="!(orderGiftItems.length !== 0 && userInfo.userType == 'common' &&
            userInfo.statusName == 'normal' && orderGiftItems[0].goodsType == 2)" title="商品合计"
            :value="'￥' + formatPrice(actualPrice)" class="computedPrice"></van-cell>
          <van-cell v-for="discount in order.orderDiscounts" :key="discount.discountTitle" :border="false" title="优惠金额"
            :value="'-￥' + discount.discountAmount"></van-cell>
          <!-- win 新人大礼包 -->
          <van-cell v-if="(userInfo.userType !== 'common' ||
            userInfo.statusName !== 'limited') && orderGiftItems.length !== 0 && orderGiftItems[0].goodsType == 2"
            title="新人首单大礼包" :value="'￥' + formatPrice(orderGiftItems[0].price)" class="computedPrice"></van-cell>
          <van-cell border title="实付金额" :value="'￥' + formatPrice(order.orderPrice)" value-class="checkout-sum"
            class="computedPrice"></van-cell>
        </div>
        <div class="order-info">
          <p>下单时间：{{ order.orderTime }}</p>
          <p v-if="order.orderStatus !== 'submitted' && order.orderStatus !== 'cancelled'">支付时间：{{
            formatDate(order.payTime) }}
          </p>
          <p>订单编号：{{ order.orderId }}</p>
        </div>
        <div v-if="order.orderStatus == 'shipped'">
          <div v-for="(item, index) in order.orderExpressInfo" :key="index" class="order-info between">
            <div class="flex">
              <div v-if="
                order.orderExpressInfo !== null &&
                order.orderExpressInfo.length > 1
              ">
                包裹 {{ index + 1 }}：
              </div>
              <div @click="onClickExpress(item)">
                <p>物流公司：{{ item.name }}</p>
                <p>
                  快递单号：{{ item.no }}
                  <span @click="copyActiveCode($event, item.no)" class="code">复制</span>
                </p>
              </div>
            </div>
            <div>
              <a class="red" @click="onLook(item)">查看</a>
              <!-- <button @click="onLook(item)">查看</button> -->
            </div>
          </div>
        </div>
        <van-submit-bar :disabled="button.disabled" :loading="button.loading" :price="order.orderPrice * 100"
          button-text="付款" @submit="onSubmit" v-if="button.display" />
      </van-panel>
    </van-list>
  </div>
</template>
<script>
import {
  Cell,
  Tag,
  List,
  Card,
  Panel,
  SubmitBar,
  Dialog,
  Toast,
  Loading,
  Step,
  Steps,
  Popup,
  Icon,
  Overlay,
  Notify,
} from "vant";
import serviceOrder from "../../api/order/index";
import service from "../../api/express";
import servicePay from "../../api/payment/wxpay/index";
import { wxPay } from "../../util/wxHelper";
import loading from "../../components/loading/loading";
import { parseTime } from "../../util/date.js";
import Clipboard from "clipboard";
import { mapGetters } from "vuex";
export default {
  components: {
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [List.name]: List,
    [Card.name]: Card,
    [Panel.name]: Panel,
    [SubmitBar.name]: SubmitBar,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup,
    [Notify.name]: Notify,
    loading,
  },
  data() {
    return {
      show: false,
      active: 0,
      steps: { result: {} },
      expressNo: 0,
      isLoading: true, //loading状态
      minutes: 5,
      // Timer: 0,
      address: {},
      skuList: [],
      coupon: {
        list: [],
        price: 0,
      },
      orderPrice: 0,
      fromType: 0,
      button: {
        disabled: false,
        loading: false,
        display: false,
      },
      orderStatusText: "",
      orderNo: "",
      orderDate: "",
      orderStatusId: "",
      // isShowLoading: false,
      order: {
        orderPrice: 0,
        orderStatus: "",
      },
      orderGiftItems: [],
      // order: {
      //   orderStatus: ""
      // }
    };
  },
  watch: {
    // 倒计时
    minute: {
      handler(newVal) {
        this.num(newVal);
      },
    },
  },
  computed: {
    // 倒计时
    minute: function () {
      return this.num(this.minutes);
    },
    cardType() {
      return this.chosenContactId !== null ? "edit" : "add";
    },
    currentContact() {
      const id = this.chosenContactId;
      return id !== null ? this.list.filter((item) => item.id === id)[0] : {};
    },
    // win 商品价格不包含新人大礼包
    actualPrice: {
      get() {
        console.log(this.order.orderItems, 'this.order.orderItems')
        let price = 0;
        if (this.order.orderItems !== undefined) {
          this.order.orderItems.map((v) => {
            price += v.price * v.quantity;
          });
        }
        return price;
      },
      set() { },
    },
    ...mapGetters(["userInfo"]),
  },
  methods: {
    copy() {
      var clipboard = new Clipboard(".code");
      clipboard.on("success", (e) => {
        Toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("手机权限不支持复制功能");
        // 释放内存
        clipboard.destroy();
      });
    },
    callPhone(phoneNumber) {
      Dialog.confirm({
        title: "标题",
        message: "是否拨打?",
      })
        .then(() => {
          // on confirm;
          window.location.href = "tel://" + phoneNumber;
        })
        .catch(() => {
          // on cancel
        });
    },
    num(n) {
      // 倒计时结束重新刷新页面
      if (this.minutes === 0) {
        this.init(this.$route.query.id);
      }
    },
    // 倒计时
    // timer() {
    // },
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    formatDate(str) {
      const [d, t] = str.split(' ');
      const [m, d_, y] = d.split('/');
      return `${y}-${m}-${d_} ${t}`;
    },
    onClickExpress(item) {
      console.log(item);
      // this.$router.push({ name: "express", query: { expressAll: item } });
    },
    onLook(item) {
      this.show = true;
      this.isLoading = true;
      this.steps = { result: {} };
      service.post({ no: item.no, name: item.name }).then((response) => {
        if (response.statusCode == 200) {
          response.data = JSON.parse(response.data);
          setTimeout(() => {
            this.isLoading = false;
          }, 600);
          // console.log(response,response.data.result.list.reverse(), 185);
          switch (response.data.status) {
            case "0":
              {
                this.steps = response.data;
              }
              break;
            case "203":
              Notify({
                type: "danger",
                message: response.data.msg,
              });
              this.steps = response.data;
              // response.data.result.list=response.data.result.list.reverse()
              // this.steps = response.data.result;
              break;
            case 205:
              this.steps = response.data;
              break;
            case "201":
              Notify({
                type: "danger",
                message: response.data.msg,
              });
              this.steps = response.data;
              break;
            case 204:
              Notify({
                type: "danger",
                message: response.data.msg,
              });
              this.steps = response.data;
              break;
            case 207:
              Notify({
                type: "danger",
                message: response.data.msg,
              });
              this.steps = response.data;
              break;
          }
        } else {
          Toast(response.errors);
        }
      });
      // this.$router.push("express");
    },
    copyActiveCode(e, text) {
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        Toast("复制成功");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("手机权限不支持复制功能");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    copyCodeOrder(e, text) {
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        Toast("复制成功");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("手机权限不支持复制功能");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    onSubmit() {
      this.isLoading = true;
      // Toast.loading({
      //   message: "加载中...",
      //   forbidClick: true,
      //   loadingType: "spinner"
      // });
      serviceOrder.checkOrderExpire(this.orderNo).then((res) => {
        if (res.statusCode == 200) {
          if (res.data) {
            // 如果为true
            this.unifiedOrderPay();
            this.isLoading = false;
          } else {
            Toast("订单异常无法支付");
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
          Toast(res.errors);
        }
      });
    },
    unifiedOrderPay() {
      this.isLoading = true;
      servicePay
        .unifiedOrder(this.orderNo, this.userInfo.openId)
        .then((response) => {
          // Toast.clear();
          setTimeout(() => {
            this.isLoading = false;
          }, 3000);
          this.$log.debug("onPay", response.data);
          wxPay(response.data)
            .then((res) => {
              if (response.statusCode == 200) {
                this.$router.replace({
                  name: "payResult",
                  query: { id: this.orderNo, status: true },
                });
              } else {
                // Toast(response.errors);
                this.$router.replace({
                  name: "payResult",
                  query: { id: this.orderNo, status: false },
                });
              }
            })
            .catch((err) => {
              this.$router.replace({
                name: "payResult",
                query: { id: this.orderNo, status: false },
              });
            });
        })
        .catch();
    },
    init() {
      serviceOrder
        .detail(this.orderNo)
        .then((response) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          let data = response.data;
          this.order = data;
          this.orderGiftItems = data.orderGiftItems;
          // this.timer();
          this.button.disabled = false;
          this.button.display = data.orderStatus == "submitted";
        })
        .catch((error) => { });
    },
    getChineseStatus(orderStatusText) {
      switch (orderStatusText) {
        case "submitted":
          return "待支付";
        case "paid":
          return "已支付";
        case "shipped":
          return "已发货";
        case "refund":
          return "申请退款";
        case "refunded":
          return "已退款";
        case "completed":
          return "订单完成";
        case "cancelled":
          return "已取消";
        default:
          break;
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.orderStatus == "submitted") {
      Dialog.confirm({
        title: "确定离开",
        message: "您的订单在5分钟内未支付将被取消，请尽快完成支付。",
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  mounted() {
    if (this.$route.query.orderStatusId) {
      localStorage.setItem(
        "backOrderId",
        JSON.stringify(this.$route.query.orderStatusId)
      );
    }
    this.orderNo = this.$route.query.id;
    this.init(this.$route.query.id);
  },
};
</script>
<style lang="less" scoped>
.orderContainer {
  width: 100%;
  overflow: auto;
  overflow-x: hidden;
  min-height: 100vh;

  .orderHeaderTopBetween {
    display: flex;
    align-items: center;
  }

  .codeOrderId {
    color: #929292;
    margin-left: 8px;
    background: #ffffff;
    border: 0.5px solid rgba(143, 143, 143, 1);
    border-radius: 10px;
    width: 36px;
    height: 16px;
    font-size: 2.67vw;
    text-align: center;
    line-height: 16px;
  }

  .van-card__desc {
    padding-top: 1vw;
  }

  .van-submit-bar {
    border-top: 1px solid #f7f7f7;
  }

  .orderBottom {
    height: 16vw;
    display: flex;
  }

  .cardList {
    margin-bottom: 20vw;
    width: 100%;
  }

  .flex-between {
    font-size: 14px;
  }

  .van-cell__label {
    width: 100%;
    white-space: inherit;
    word-break: break-all;
  }

  .fix-position {
    width: 100%;
  }

  .order-info {
    padding: 2vw 0;
    margin: 0 4.2vw;
    font-size: 12px;
    color: #929292;
    border-bottom: 1px solid #f8f8f8;
  }

  .shopCard {

    // border-top: 1px solid #f7f7f7;
    .van-card__content {
      padding-left: 5px;
    }

    .van-card__bottom {
      line-height: 8.33333vw;

      // .van-card__price {
      //   font-size: 16px;
      //   padding: 6px 0;
      //   color: #ee0a24;
      // }
      .van-card__num {
        padding: 0 5px;
        color: #7d7e80;
        font-size: 3.73333vw;
      }
    }
  }
}
</style>
